module.exports = __webpack_public_path__ + "static/media/rora-grabient@2x.336012f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rora-grabient@2x.png
// module id = 475
// module chunks = 0